var path = '/glow/glow.tpl.html';
var html = "<div class=container-fluid id=glow-page ng-style=styles.glow_page ui-view=glow-page></div> <div class=container-fluid ui-view=glow-modal></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/glow.tpl.html
// module id = 1687
// module chunks = 1